import { onResize, popError, pushError, onInteraction } from "../slices/slide.App";

export const action_setViewportData =
  (width: number, height: number, isLandscape: boolean) => (dispatch: any) => {
    dispatch(
      onResize({
        width,
        height,
        isLandscape,
      })
    );
  };

// adds an error to the state errors stack (code and error description are optional)
export const action_pushError =
  (
    _eSeverity: string,
    _errText: string,
    _errCode: string | number,
    _errDesc?: string
  ) =>
  (dispatch: any) => {
    dispatch(
      pushError({
        severity: _eSeverity,
        text: _errText,
        code: _errCode,
        errdesc: _errDesc,
      })
    );
  };

// removes one error from the stack
export const action_popError = () => (dispatch: any) => {
  dispatch(popError({}));
};

export const action_setUserInteraction =
  (interaction: boolean) => (dispatch: any) => {
    dispatch(onInteraction(interaction));
  };
